import { DECREASE, INCREASE } from "./ActionIdentifier";

const initialState = {
    Dell: {
        items: 0,
        price: 0,
    },
    Asus: {
        items: 0,
        price: 0,
    },
    Canon: {
        items: 0,
        price: 0,
    },
};

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case INCREASE:
            return {
                ...state,
                [`${action.payload.product}`]: {
                    ...state[`${action.payload.product}`],
                    items: state[`${action.payload.product}`].items + 1,
                    price:
                        state[`${action.payload.product}`].price +
                        action.payload.price,
                },
            };

        case DECREASE:
            return {
                ...state,
                [`${action.payload.product}`]: {
                    ...state[`${action.payload.product}`],
                    items: state[`${action.payload.product}`].items - 1,
                    price:
                        state[`${action.payload.product}`].price -
                        action.payload.price,
                },
            };

        default:
            return state;
    }
};

export default cartReducer;
